import {getState, dispatch} from '../../lib/store';
import types from '../../reducers/modules/types';
import API from '../../lib/api';

const init = async() => {
    console.log(`INIT`);

    const {modules} = getState(),
          {module_modals} = modules;
          
    if(module_modals.length < 1) {
        // console.log(`NO MODALS`);
        return setTimeout(init, 3e3);
    }

    const has_visible = module_modals.filter(m => m.visible)[0] || null;

    if(has_visible) {
        // console.log('HAS VISIBLE');
        return setTimeout(init, 3e3);
    }

    const response = await API.call({
        path: '/modules/modalShow',
        body: {
            triggerId: module_modals[0].triggerId,
            communicationId: module_modals[0].communicationId
        }
    });

    dispatch({
        type: types.module_modals.show,
        payload: {
            key: module_modals[0].key,
            triggerId: module_modals[0].triggerId
        }
    });

    return setTimeout(init, 3e3);
}

export default {
    init
}